// extracted by mini-css-extract-plugin
module.exports = {"viewRelated":"styles_viewRelated__xgLpK","loader":"styles_loader__1etoP"};